import { useEffect, useRef } from "react";

const SyncFormikValues = ({ values, setStepsData, step }) => {
    const prevJson = useRef("");

    useEffect(() => {
        const curJson = JSON.stringify(values);

        if (prevJson.current !== curJson) {
            setStepsData(prev => {
                if (prev?.updateSteps1) {
                    return {
                        ...prev,
                        updateSteps1: undefined,
                    }
                }
                if (prev[step] && JSON.stringify(prev[step]) === curJson) return prev;
                return { ...prev, [step]: { ...values } };
            });
            prevJson.current = curJson;
        }
    }, [values, setStepsData, step]);

    return null;
};

export default SyncFormikValues;